<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Loaders" pageTitle="Loaders" />
            <LoadersContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import LoadersContent from '../Loaders/LoadersContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'LoadersPage',
    components: {
        MainHeader,
        PageTitle,
        LoadersContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>